import { SearchInput as BaseSearch, type SearchInputProps} from '../agent-helper/search-input';

export type { SearchInputProps };

export const SearchInput = (props: SearchInputProps) => <BaseSearch {...props} placeholder="搜索表单或字段"  />;